import React, { useContext, useEffect, useState } from 'react';
import { CardsContext } from "../../../CardsContext";
import { Checkbox } from '../../Checkbox/Checkbox';
import { Button } from '../../Button';
import { SearchList } from './SearchList';
import { ResetIcon } from '../../../icons/Reset';
import { useFilteredCards } from '../../../hooks/useFilteredCards';
import './FormPopup.scss';

export function FormPopup({ filter, filterItems, onChange, onReset, ...props }) {
  const { isTargetClasses, cards } = useContext(CardsContext);
  const [filterValues, setFilterValues] = useState(filter);
  const filteredClasses = useFilteredCards(cards, filterValues, isTargetClasses);

  useEffect(() => {
    setFilterValues(filter);
  }, [filter]);

  function changeFilter(item, value, type) {
    switch(type) {
      case 'set':
        setFilterValues((prevFilter) => ({
          ...prevFilter,
          [item]: value
        }));
        break;
      case 'add':
        setFilterValues((prevFilter) => ({
          ...prevFilter,
          [item]: prevFilter[item].concat(value)
        }));
        break;
      case 'remove':
        setFilterValues((prevFilter) => ({
          ...prevFilter,
          [item]: prevFilter[item].filter((itemValue) => itemValue !== value)
        }));
        break;
      default:
        return;
    }
  }

  function applyFilter() {
    const filters = Object.keys(filterValues)
                      .filter(i => i !== 'sortBy' && i !== 'hasSeries')
                      .map(itm => {return {"type": itm, "value": filterValues[itm]}});

    //actid=50
    window.analytics?.track("filter:set", {
      "filters": filters,
      "sorts": filterValues.sortBy,
    });

    onChange(filterValues);
  }

  return (
    <div className="FormPopup" {...props}>
      <div className="FormPopup__content">
        <div className="FormPopup__section">
          <span className="FormPopup__section-label">Access</span>

          <div className="FormPopup__section-content">
            {filterItems.access.map((item) => (
              <Checkbox
                className="FormPopup__checkbox"
                checked={filterValues.access.includes(item)}
                onChange={(e) => changeFilter('access', item, e.target.checked ? 'add' : 'remove')}
                key={item}
              >
                <span dangerouslySetInnerHTML={{ __html: item }} />
              </Checkbox>
            ))}
          </div>
        </div>

        <div className="FormPopup__section">
          <span className="FormPopup__section-label">Type</span>

          <div className="FormPopup__section-content">
            {filterItems.type.map((item) => (
              <Checkbox
                className="FormPopup__checkbox"
                checked={filterValues.type.includes(item)}
                onChange={(e) => changeFilter('type', item, e.target.checked ? 'add' : 'remove')}
                key={item}
              >
                <span dangerouslySetInnerHTML={{ __html: item }} />
              </Checkbox>
            ))}
          </div>
        </div>

        <div className="FormPopup__section">
          <span className="FormPopup__section-label">Level</span>

          <div className="FormPopup__section-content">
            {filterItems.level.map((item) => (
              <Checkbox
                className="FormPopup__checkbox"
                checked={filterValues.level.includes(item)}
                onChange={(e) => changeFilter('level', item, e.target.checked ? 'add' : 'remove')}
                key={item}
              >
                <span dangerouslySetInnerHTML={{ __html: item }} />
              </Checkbox>
            ))}
          </div>
        </div>

        {isTargetClasses && (
          <div className="FormPopup__section">
            <span className="FormPopup__section-label">Subjects</span>

            <div className="FormPopup__section-content">
              {filterItems.subjects.map((item) => (
                <Checkbox
                  className="FormPopup__checkbox"
                  checked={filterValues.subjects.includes(item)}
                  onChange={(e) => changeFilter('subjects', item, e.target.checked ? 'add' : 'remove')}
                  key={item}
                >
                  <span dangerouslySetInnerHTML={{ __html: item }} />
                </Checkbox>
              ))}
            </div>
          </div>
        )}

        <div className="FormPopup__section">
          <span className="FormPopup__section-label">Sort by</span>

          <div className="FormPopup__section-content">
            {filterItems.sortBy.map((item) => (
              <Checkbox
                className="FormPopup__checkbox"
                checked={filterValues.sortBy === item}
                onChange={(e) => e.target.checked && changeFilter('sortBy', item, 'set')}
                key={item}
              >
                <span dangerouslySetInnerHTML={{ __html: item }} />
              </Checkbox>
            ))}
          </div>
        </div>

        <div className="FormPopup__section">
          <span className="FormPopup__section-label">Coach</span>
          <SearchList
            list={filterItems.coach.map((coach) => ({
              value: coach.id,
              name: coach.title,
              image: coach.ava
            }))}
            selected={filterValues.coach}
            onChange={(items) => changeFilter('coach', items, 'set')}
          />
        </div>

        <div className="FormPopup__buttons">
          <Button
            type="primary"
            className="FormPopup__apply-btn"
            onClick={applyFilter}
          >
            Apply filters ({filteredClasses.length})
          </Button>
          <Button
            className="FormPopup__reset-btn"
            icon={<span className="anticon"><ResetIcon /></span>}
            onClick={onReset}
          >
            Reset
          </Button>
        </div>
      </div>
    </div>
  );
}
